// 5 Glow Challenges with full day-by-day content.

export const CHALLENGES = [
  {
    id: "glow-reset-7",
    name: "7-Day Glow Reset",
    emoji: "🌟",
    duration: 7,
    difficulty: "Beginner",
    categories: ["Skin"],
    goal: "Reset, hydrate, and rebuild your glow in one week",
    motivation: "Seven days. Seven small rituals. A reset your skin will remember.",
    premium: false,
    achievements: [
      "Visibly hydrated skin",
      "Reduced dullness",
      "Balanced moisture barrier",
      "Glowing complexion",
    ],
    avoidFoods: ["Refined sugar", "Fried foods", "Dairy", "Alcohol", "Processed snacks", "White bread"],
    drinkDaily: ["2-3 litres of water", "Green tea", "Cucumber-infused water", "Celery juice in the morning"],
    days: [
      {
        title: "Cleanse and Reset",
        tasks: [
          "Double cleanse morning and evening",
          "Apply hydrating toner with hyaluronic acid",
          "Use a gentle exfoliating mask for 10 minutes",
          "Drink 2 litres of water",
          "Avoid all sugar today",
          "Sleep on a clean pillowcase",
        ],
      },
      {
        title: "Deep Hydration",
        tasks: [
          "Apply hydrating serum morning and night",
          "Use a sheet mask for 20 minutes",
          "Add a humidifier to your room if possible",
          "Drink green tea",
          "Eat water-rich foods like cucumber and watermelon",
          "No alcohol today",
        ],
      },
      {
        title: "Barrier Repair",
        tasks: [
          "Use ceramide moisturizer morning and night",
          "Apply facial oil as final step in PM routine",
          "No harsh actives today",
          "Scalp massage for 5 minutes",
          "Drink celery juice this morning",
          "Sleep with hair away from face",
        ],
      },
      {
        title: "Brightening Day",
        tasks: [
          "Apply vitamin C serum this morning",
          "Use SPF 50 without fail",
          "Eat berries and citrus fruits today",
          "Turmeric glow mask for 15 minutes this evening",
          "Drink lemon water",
          "Avoid fried foods",
        ],
      },
      {
        title: "Nourishment Day",
        tasks: [
          "Facial massage with face oil for 5 minutes",
          "Apply eye cream morning and night",
          "Eat salmon or avocado today for omega-3",
          "Drink 3 litres of water",
          "Do a 10 minute facial gua sha or jade roller session",
          "Avoid dairy today",
        ],
      },
      {
        title: "Detox Day",
        tasks: [
          "Clay mask for 15 minutes",
          "Double cleanse thoroughly",
          "Drink detox water with lemon and ginger",
          "Eat leafy greens today",
          "No processed food",
          "Apply niacinamide serum to even skin tone",
          "8 hours sleep tonight",
        ],
      },
      {
        title: "Glow Seal",
        tasks: [
          "Full AM routine with vitamin C and SPF",
          "Take a before and after photo in the same lighting",
          "Apply your richest moisturizer as a mask tonight",
          "Drink green tea",
          "Celebrate your 7 day commitment",
          "Complete your skin check-in to see your Glow Score change",
        ],
      },
    ],
  },
  {
    id: "hair-growth-21",
    name: "21-Day Hair Growth Sprint",
    emoji: "🌱",
    duration: 21,
    difficulty: "Intermediate",
    categories: ["Hair"],
    goal: "Stimulate scalp, strengthen strands, and accelerate growth",
    motivation: "Three weeks of intentional care. Your scalp is the soil — let's tend to it.",
    premium: true,
    achievements: [
      "Stronger strands",
      "Reduced breakage",
      "Stimulated scalp",
      "Noticeable length retention",
    ],
    eatDaily: ["Biotin-rich eggs", "Spinach", "Sweet potato", "Nuts and seeds", "Avocado"],
    avoidFoods: ["Excess alcohol", "Refined sugar", "Fast food"],
    drinkDaily: ["Water", "Biotin supplement if available", "Green smoothies"],
    weeks: [
      { title: "Scalp Health", focus: "Wake up dormant follicles" },
      { title: "Strengthen", focus: "Build resilience and reduce breakage" },
      { title: "Length Retention", focus: "Lock in every millimetre you grow" },
    ],
    days: [
      // Week 1 — Scalp Health (Days 1-7)
      { title: "Day 1 — Scalp Wake-Up", tasks: ["5 minute scalp massage with black castor oil", "Protective style during the day", "Silk bonnet at night", "Drink 2 litres of water"] },
      { title: "Day 2", tasks: ["Scalp massage with peppermint oil", "LOC method on natural hair", "No heat styling", "Eat 2 eggs today"] },
      { title: "Day 3", tasks: ["Apply rosemary oil to scalp", "Detangle gently on damp hair", "Spinach salad with lunch", "Hydrate with 2L water"] },
      { title: "Day 4", tasks: ["Scalp massage 5 minutes", "Refresh with leave-in spray", "Eat avocado today", "Satin bonnet"] },
      { title: "Day 5", tasks: ["Castor oil treatment overnight", "Pineapple style for sleep", "Sweet potato with dinner", "No fast food"] },
      { title: "Day 6", tasks: ["Tea tree oil for scalp", "Loose protective style", "Pumpkin seeds snack", "Hydrate"] },
      { title: "Day 7 — Wash Day", tasks: ["Sulfate-free shampoo", "Deep condition 30 min", "LOC method generously", "Length check photo"] },
      // Week 2 — Strengthen (Days 8-14)
      { title: "Day 8 — Protein Treatment", tasks: ["Apply protein mask 15 min", "Rinse cool", "LOC method", "Eat salmon or eggs"] },
      { title: "Day 9", tasks: ["Scalp massage 5 min", "Light oil to ends", "Avoid heat", "Berry smoothie"] },
      { title: "Day 10 — ACV Rinse", tasks: ["Apple cider vinegar rinse (1:4 dilution)", "Deep condition", "LOC method", "Hydrate"] },
      { title: "Day 11", tasks: ["Scalp oiling massage", "Protective style", "Eat nuts and seeds", "Satin bonnet"] },
      { title: "Day 12 — Deep Condition", tasks: ["Deep conditioner 30 min with heat cap", "Detangle gently", "Rinse cool", "Lock with cream"] },
      { title: "Day 13", tasks: ["Scalp massage", "Refresh ends", "Eat leafy greens", "Hydrate 3L"] },
      { title: "Day 14 — Trim Day", tasks: ["Trim split ends only", "Length check photo", "Celebrate week 2", "Protective style"] },
      // Week 3 — Length Retention (Days 15-21)
      { title: "Day 15 — Rice Water", tasks: ["Apply fermented rice water 10 min", "Rinse and deep condition", "LOC method", "Avocado meal"] },
      { title: "Day 16", tasks: ["Maintain protective style", "Light scalp oil", "Hydrate", "Sleep 8 hours"] },
      { title: "Day 17 — Peppermint Massage", tasks: ["Peppermint oil scalp massage 10 min", "Refresh ends", "Eat eggs and spinach", "Bonnet"] },
      { title: "Day 18", tasks: ["Scalp oil", "Light detangle", "Healthy snack: nuts", "No alcohol today"] },
      { title: "Day 19 — Final Deep Condition", tasks: ["Deep condition 30 min", "Cool rinse", "LCO method", "Hydrate"] },
      { title: "Day 20", tasks: ["Scalp massage", "Protective style", "Green smoothie", "Bonnet"] },
      { title: "Day 21 — Length Check", tasks: ["Final length check photo", "Compare to Day 1", "Celebrate your retention", "Take rest day"] },
    ],
  },
  {
    id: "no-heat-30",
    name: "30-Day No-Heat Challenge",
    emoji: "❄️",
    duration: 30,
    difficulty: "Intermediate",
    categories: ["Hair"],
    goal: "Rest your strands, embrace natural texture, reduce damage",
    motivation: "Thirty days of letting your hair just be. Your natural texture is a crown.",
    premium: true,
    achievements: [
      "Reduced breakage",
      "Healthier ends",
      "Defined natural texture",
      "Stronger hair",
    ],
    weeks: [
      { title: "Learning Your Texture", focus: "Daily moisture, LOC, protective styles" },
      { title: "Deep Nourishment", focus: "Weekly protein, scalp oiling, twist-outs" },
      { title: "Embracing Definition", focus: "Wash and gos, curl-defining products" },
      { title: "Sealing the Growth", focus: "Final deep condition, before and after" },
    ],
    days: Array.from({ length: 30 }, (_, i) => {
      const week = Math.min(Math.floor(i / 7), 3);
      const themes = [
        "Daily moisturizing, LOC method, protective styles",
        "Weekly protein treatment, scalp oiling, twist-outs",
        "Wash and go techniques, curl defining products, length check",
        "Final deep condition, celebrate natural texture, before and after photos",
      ];
      const focuses = [
        ["LOC method on damp hair", "Silk bonnet at night", "No heat styling", "Drink 2L water"],
        ["Apply protein mask", "Scalp massage 5 min", "Twist-out style", "Eat omega-3 foods"],
        ["Wash and go technique", "Curl defining cream", "Diffuse on low if needed (no direct heat)", "Refresh with leave-in"],
        ["Deep conditioner", "Length check photo", "Celebrate texture", "LOC method generously"],
      ];
      return {
        title: `Day ${i + 1} — ${themes[week].split(",")[0]}`,
        tasks: focuses[week],
      };
    }),
  },
  {
    id: "hydration-hero-14",
    name: "14-Day Hydration Hero",
    emoji: "💧",
    duration: 14,
    difficulty: "Beginner",
    categories: ["Skin", "Wellness"],
    goal: "Achieve dewy, glass skin through deep hydration inside and out",
    motivation: "Glass skin starts with consistent hydration. Two weeks, plump and dewy.",
    premium: false,
    achievements: [
      "Plumper skin",
      "Reduced fine lines",
      "Glowing complexion",
      "Improved skin elasticity",
    ],
    avoidFoods: ["Salty snacks", "Alcohol", "Caffeine excess", "Fried food"],
    drinkDaily: ["3 litres of water", "Coconut water", "Cucumber water", "Herbal teas"],
    days: Array.from({ length: 14 }, (_, i) => {
      const cycles = [
        { title: "Hyaluronic Boost", tasks: ["Apply HA serum on damp skin AM and PM", "Drink 3L water", "Cucumber slices for breakfast", "Mist face every 3 hours"] },
        { title: "Sheet Mask Day", tasks: ["20-min sheet mask", "Coconut water", "Add a humidifier if possible", "Avoid salty foods"] },
        { title: "Water Tracking", tasks: ["Track every glass of water", "Hydrating face oil at night", "Eat watermelon and berries", "Herbal tea evening"] },
        { title: "Humidify and Mist", tasks: ["Mist face hourly", "Add humidifier to bedroom", "Drink 3L water", "Eat soup or broth"] },
        { title: "Hydrating Foods", tasks: ["Eat cucumber, watermelon, celery, oranges", "Apply HA + niacinamide serum", "Drink coconut water", "No alcohol"] },
        { title: "Facial Misting", tasks: ["Mist 4-6 times today", "Drink 3L water", "Use hydrating toner", "Sleep with HA-infused pillowcase or satin"] },
        { title: "Sleeping Mask Night", tasks: ["Overnight hydrating mask", "Take a humidifier-friendly nap", "Drink herbal tea", "Avoid caffeine after 2pm"] },
      ];
      return cycles[i % 7];
    }),
  },
  {
    id: "dark-spot-10",
    name: "10-Day Dark Spot Focus",
    emoji: "✨",
    duration: 10,
    difficulty: "Intermediate",
    categories: ["Skin"],
    goal: "Fade hyperpigmentation and achieve even, glowing skin",
    motivation: "Patience plus SPF plus consistency = a brighter, more even complexion in ten days.",
    premium: true,
    achievements: [
      "Visibly faded dark spots",
      "More even skin tone",
      "Brighter complexion",
    ],
    avoidFoods: ["Sugar", "Alcohol", "Foods that cause inflammation"],
    drinkDaily: ["Lemon water", "Vitamin C rich juices", "Green tea", "Lots of water"],
    mustDo: "SPF 50 every single morning without exception — sun exposure darkens spots",
    days: [
      { title: "Day 1 — Foundation", tasks: ["Apply vitamin C serum AM", "SPF 50 (non-negotiable)", "Niacinamide serum PM", "Drink lemon water"] },
      { title: "Day 2", tasks: ["Vitamin C + SPF AM", "Niacinamide PM", "Avoid sun exposure", "Green tea today"] },
      { title: "Day 3 — Turmeric Mask", tasks: ["Vitamin C + SPF", "Turmeric glow mask 15 min PM", "Drink 3L water", "No sugar"] },
      { title: "Day 4", tasks: ["Vitamin C + SPF", "Niacinamide PM", "Add alpha arbutin if available", "Eat citrus and berries"] },
      { title: "Day 5", tasks: ["Vitamin C + SPF", "Tranexamic acid serum if available", "Avoid alcohol", "Drink lemon water"] },
      { title: "Day 6", tasks: ["Vitamin C + SPF", "Niacinamide PM", "Anti-inflammatory diet (no fried foods)", "Green tea"] },
      { title: "Day 7 — Turmeric Mask", tasks: ["Vitamin C + SPF", "Turmeric mask 15 min", "Niacinamide PM", "Drink 3L water"] },
      { title: "Day 8", tasks: ["Vitamin C + SPF", "Kojic acid treatment if available", "Avoid sun exposure", "Vitamin C-rich juice"] },
      { title: "Day 9", tasks: ["Vitamin C + SPF", "Niacinamide PM", "Hydrating mask 20 min", "Eat colorful vegetables"] },
      { title: "Day 10 — Glow Reveal", tasks: ["Final vitamin C + SPF", "Compare before/after photo", "Celebrate with glow ritual", "Maintain SPF 50 daily forever"] },
    ],
  },
];

// Badge definitions — awarded based on streak / completion.
export const BADGES = [
  { id: "first-routine", name: "First Ritual", emoji: "🌸", description: "Completed your first AM or PM routine" },
  { id: "streak-3", name: "3-Day Glow", emoji: "✨", description: "3-day routine streak" },
  { id: "streak-7", name: "Week Warrior", emoji: "🔥", description: "7-day routine streak" },
  { id: "streak-14", name: "Two-Week Glow", emoji: "🌟", description: "14-day routine streak" },
  { id: "streak-30", name: "Glow Master", emoji: "👑", description: "30-day routine streak" },
  { id: "first-wash-day", name: "Wash Day Won", emoji: "💆🏾‍♀️", description: "Completed your first wash day" },
  { id: "challenge-glow-reset", name: "Reset Complete", emoji: "🌟", description: "Finished the 7-Day Glow Reset" },
  { id: "challenge-hydration", name: "Hydration Hero", emoji: "💧", description: "Finished the 14-Day Hydration Hero" },
];

export function streakMessage(streak) {
  if (streak >= 30) return "30 days — you are a glow master.";
  if (streak >= 14) return `${streak} day streak — your skin is thanking you.`;
  if (streak >= 7) return `${streak} day streak — you are glowing!`;
  if (streak >= 3) return `${streak} days in a row — momentum is everything.`;
  if (streak >= 1) return "Day one of your glow journey starts now.";
  return "Start today and watch your streak grow.";
}
